import { useCallback, useEffect, useState } from 'react';

const CLAVE = 'miu-tema';

/**
 * Tema claro u oscuro.
 * - Predeterminado: claro, independientemente del tema del dispositivo.
 * - La elección manual se recuerda en este navegador (si el almacenamiento está disponible).
 */
export function useTema(): [boolean, () => void] {
  const [oscuro, setOscuro] = useState<boolean>(() => {
    try { return window.localStorage.getItem(CLAVE) === 'oscuro'; } catch { return false; }
  });

  useEffect(() => {
    try { window.localStorage.setItem(CLAVE, oscuro ? 'oscuro' : 'claro'); } catch { /* sin almacenamiento */ }
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute('content', oscuro ? '#1F1A16' : '#FAF6EF');
    document.documentElement.style.background = oscuro ? '#1F1A16' : '#FAF6EF';
  }, [oscuro]);

  const alternar = useCallback(() => setOscuro((o) => !o), []);
  return [oscuro, alternar];
}
